export default {
  default: {
    title: 'Edit Quote Template | Engage',
  },
}
